export default "__VITE_ASSET__D3MnBFMA__"